import { DynamicObjectType } from 'core/types/common';
import React from 'react';
import { ShowWrapper } from './styles';
import OrderSummary from './OrderSummary';
import { Col, Row } from 'antd';
import LeftContent from './LeftContent';
import RightContent from './RightContent';

const ShowContent = ({ data }: { data: DynamicObjectType }) => {
  return (
    <ShowWrapper>
      <OrderSummary data={data} />
      <br />
      <Row gutter={[20, 20]}>
        <Col md={15}>
          <LeftContent data={data} />
        </Col>
        <Col md={9}>
          <RightContent data={data} />
        </Col>
      </Row>
    </ShowWrapper>
  );
};

export default ShowContent;
